const env = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    mapbox: {
        username: process.env.REACT_APP_MAPBOX_USERNAME,
        uploadToken: process.env.REACT_APP_MAPBOX_UPLOAD_TOKEN,
        satelliteStyleID: process.env.REACT_APP_MAPBOX_SATELLITE_ID,
    }
}

export default env